import styled from "styled-components";

export const PageTitle = styled.h1`
  font-weight: 300;
  color: var(--default);
  width: 100%;
  border-bottom: 1px solid var(--gray-light);
  text-align: center;
  text-transform: uppercase;
  padding-bottom: 24px;
`;


